// extracted by mini-css-extract-plugin
export default {"content":"content___hILkx","arrow":"arrow___SN6_W","save":"save___IPf10"};